// extracted by mini-css-extract-plugin
export var adjustableWidthBorder = "_4h-7";
export var adjustableWidthBorderHeld = "_4h-8";
export var arrow = "_4h-3";
export var arrowButton = "_4h-4";
export var headerCell = "_4h-0";
export var help = "_4h-2";
export var icon = "_4h-1";
export var iconWrapper = "_4h-6";
export var noBorder = "_4h-b";
export var nonAdjustableWidthBorder = "_4h-9";
export var nonAdjustableWidthBorderHeld = "_4h-a";
export var textButton = "_4h-5";